<template>
<v-container fluid grid-list-lg>
  <v-layout row wrap>
    <v-flex>
      <v-card>
        <v-card-title primary-title class="primary white--text headline">
          Export Topic Model
        </v-card-title>
        <v-card-text>
          <form>
            <v-layout row>
              <v-flex xs6>
                <v-text-field
                  label="ID"
                  v-model="id"
                  disabled
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="name">
                <v-text-field
                  label="Name"
                  v-model="name"
                  disabled
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs6>
                <v-text-field
                v-model="randomDataCount"
                label="Random Data Count"
                type="number"
                v-validate="'integer'"
                data-vv-name="data count"
                :disabled="export_all"
                :error-messages="errors.collect('data count')"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-checkbox
                v-model="export_all"
                label="Export All data in this Topic Model"
                color="primary">
                </v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs6>
                <v-select
                label="Dataset"
                :items="datasets"
                v-validate="'required'"
                data-vv-name="dataset"
                :error-messages="errors.collect('dataset')"
                v-model="dataset">
                </v-select>
              </v-flex>
            </v-layout>
          </form>
        </v-card-text>
        <v-card-actions style="background: hsl(0, 0%, 97%)" class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat depressed @click.native="cancel" :disabled="analyseLoading">Cancel</v-btn>
          <v-btn color="accent" class="white--text" depressed @click.native="validateBeforeSubmit(exportItem)" :loading="analyseLoading" :disabled="analyseLoading">Download</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: {
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      analyseLoading: false,
      randomDataCount: 10,
      export_all: false,
      dataset: null,
      datasets: []
    }
  },
  created () {
    this.axios.get(`/datasets`)
      .then(response => {
        this.datasets = response.data.map((ds) => { return {text: ds.name, value: ds.id} })
      })
      .catch(error => {
        this.handleAxiosError(error)
      })
    this.axios.get(`/topic-models/${this.id}`)
      .then(response => {
        this.dataset = response.data.dataset
      })
      .catch(error => {
        this.handleAxiosError(error)
      })
  },
  methods: {
    cancel () {
      this.$router.go(-1)
    },
    exportItem () {
      if (this.export_all) {
        this.randomDataCount = 0
      } else if (this.randomDataCount < 1) {
        this.$toast.open({
          text: 'Random Data Count must be greater then 0.',
          type: 'error'
        })
        return
      }

      this.analyseLoading = true

      this.setSnack({
        message: 'Depending on the data size, this may take a while. Wait for downloading!',
        type: 'info',
        timeout: 4000
      })

      this.axios({
        url: `/topic-models/${this.id}/export/?`,
        method: 'POST',
        responseType: 'blob',
        data: {dataset_id: this.dataset, random_data_count: parseInt(this.randomDataCount)}
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'topic_model.xlsx')
          document.body.appendChild(link)
          link.click()
        })
        .catch(error => {
          this.handleAxiosError(error)
        }).finally(() => {
          this.analyseLoading = false
        })
    },
    getRandomInt (min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min
    },
    ...mapActions({
      setSnack: 'snackbar/setSnack'
    })
  }
}
</script>

<style>

</style>
